import { useHighlightStore } from '@/store/highlightStore';

export function useGlobalHighlight() {
  const { needsHighlight, setNeedsHighlight, setHighlightEnabled } = useHighlightStore();
  return { needsHighlight, setNeedsHighlight };
}